import { lookup } from 'country-data-list';

export function GetCurrencySymbol(name) {
    if (name === null || name === undefined) return '';

    return lookup?.currencies({ code: name })[0]?.symbol || '';
}

export function GetCurrencyFullName(name) {
    if (name === null || name === undefined) return '';
    return lookup?.currencies({ code: name })[0]?.name || '';
}

function Currency() {
    return null;
}

export default Currency;
